<div class="row">
  <div class="col-md-12">
    <h5>
      The program that you are registering for does not allow multiple applications.  If you have any questions or concerns please contact customer service.
    </h5>
  </div>
</div>
